<template>
	<component :is="layout"/>
</template>


<script>

import GraphQL from "../helpers/graphql.js";
import axios from "axios";
import dayjs from 'dayjs';
import 'dayjs/locale/ru'
import Layout from "./Layout.vue";
import LayoutClear from "./LayoutClear.vue";
import {nextTick} from "vue";
import {mapActions, mapState} from 'pinia'
import { useUserStore } from '../stores/User'
import 'swiper/css';

export default {
	components: {
		Layout,
		LayoutClear
	},
	data() {
		return {
			graphql: new GraphQL(),
			isLoading: false,
			noty: true,
			notyTg: true,
			darkTheme: false,
			history: {
				results: [],
				wins: []
			},
			wsAuth: false,
			bearerTokenIsSet: false,
			resizeTimeout: null
		}
	},
	mounted () {
		if (this.$cookie.get('token')) {
			this.getUser();
		} else {
			this.checkRequiredAuthPanel();
		}

		this.darkTheme = !!this.$cookie.get('darkTheme');

		let clipboard = new ClipboardJS(".isooa"),
			self = this;

		clipboard.on('success', function() {
			self.$toast.success("Успешно скопировано!");
		});
	},
	beforeDestroy () {
		window.removeEventListener('message', this.OAuthUser)
	},
	created() {
		const token = this.$cookie.get('token')
		if (token) {
			axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
		}
		window.addEventListener('message', this.OAuthUser, false);
		window.addEventListener('resize', this.handlerResize);
		this.$root.emitter.on('logout', this.logout)
	},

	unmounted() {
		window.removeEventListener('resize', this.handlerResize);
	},

	computed: {
		...mapState(useUserStore, ['user']),

		layout() {
			return this.$route.meta && this.$route.meta.layout === 'clear' ? 'LayoutClear' : 'Layout';
		}
	},

	watch: {
		'user.balance'(newBalance, oldBalance) {
			if (typeof oldBalance !== "undefined" && typeof newBalance !== "undefined") {
				this.updateBalance(newBalance, oldBalance);
			}
		},
		darkTheme(state) {
			this.handleDarkTheme(state);
		}
	},
	methods: {
		...mapActions(useUserStore, ['setUser', 'logoutUser']),

		handlerResize() {
			clearTimeout(this.resizeTimeout);
			this.resizeTimeout = setTimeout(() => this.$root.emitter.emit('updateBreakpoints'), 100);
		},

		shortLargeNumber(number) {
			const SYMBOLS = ["", "K", "M", "B", "T", "P", "E"];
			// what tier? (determines SI symbol)
			let tier = Math.log10(Math.abs(number)) / 3 | 0;

			// if zero, we don't need a suffix
			if(tier == 0) return number;

			// get suffix and determine scale
			let suffix = SYMBOLS[tier];
			let scale = Math.pow(10, tier * 3);

			// scale the number
			let scaled = number / scale;

			// format number and add suffix
			return scaled.toFixed(2) + suffix;
		},
		moment: function (date) {
			dayjs.locale('ru');

			return dayjs(date);
		},
		OAuth (provider) {
			const newWindow = this.$root.openWindow('', 'Авторизация')
			const url = this.$hostname + '/api/auth/provider/' + provider;
			newWindow.location.href = url
		},
		OAuthUser (e) {
			if (e.origin !== window.origin) {
				return
			}

			if(e.data.token) {
				this.setAuthToken(e.data.token);

				this.getUser();

				this.recordUserData();
			}

			if(e.data.attach) {
				this.getUser();
			}

			if(e.data.error) {
				this.$toast.error(e.data.text);
			}
		},
		wsAuthUser() {
			if(this.wsAuth || !this.user) {
				return;
			}

			this.$socket.emit('login', {
				id: this.user.ws_id,
			});

			this.wsAuth = true;
		},
		wsLogoutUser() {
			if(!this.wsAuth || !this.user) {
				return;
			}

			this.$socket.emit('logout', {
				id: this.user.ws_id,
			});

			this.wsAuth = false;
		},
		setAuthToken(token) {
			this.$cookie.set('token', token, { expires: "1Y" });

			axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
		},
		recordUserData() {
			if(!this.$cookie.get('token')) {
				return;
			}

			this.$fpjs.getVisitorData({
				extendedResult: true,
			}).then((visitor) => {
				this.$root.axios.post('/api/user/visit', visitor)
			});
		},
		getUser() {
			this.$root.graphql.getUser().then(res => {
				this.setUser(res);
				this.wsAuthUser();

				setTimeout(() => {
					this.updateBalance(this.user.balance, this.user.balance);
				}, 100);

				if(this.user.ban) {
					this.$router.push({name: 'index'});
				}
			}).catch(error => {
				this.$cookie.delete('token');
			});
		},

		handleDarkTheme() {
			this.darkTheme ? this.$cookie.set('darkTheme', 1, { expires: "1Y" }) : this.$cookie.delete('darkTheme');
			document.body.classList[this.darkTheme ? 'add' : 'remove']('dark-theme');
		},
		async updateOdometer(element, newValue, oldValue) {
			await nextTick();
			const el = document.getElementById(element);
			if (el) {
				const od = new Odometer({el: el, value: oldValue});
				od.update(newValue);
			}
		},
		updateBalance(newBalance, oldBalance) {
			if (this.user) {
				setTimeout(() => {
					const el = document.getElementById('userBalance');
					const od = new Odometer({el: el, value: oldBalance});
					od.update(newBalance);
				},0)
			}
		},
		openWindow (url, title, options = {}) {
			if (typeof url === 'object') {
				options = url
				url = ''
			}
			options = { url, title, width: 600, height: 720, ...options }
			const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screen.left
			const dualScreenTop = window.screenTop !== undefined ? window.screenTop : window.screen.top
			const width = window.innerWidth || document.documentElement.clientWidth || window.screen.width
			const height = window.innerHeight || document.documentElement.clientHeight || window.screen.height
			options.left = ((width / 2) - (options.width / 2)) + dualScreenLeft
			options.top = ((height / 2) - (options.height / 2)) + dualScreenTop
			const optionsStr = Object.keys(options).reduce((acc, key) => {
				acc.push(`${key}=${options[key]}`)
				return acc
			}, []).join(',')
			const newWindow = window.open(url, title, optionsStr)
			if (window.focus) {
				newWindow.focus()
			}
			return newWindow
		},
		currency(number) {
			return new Intl.NumberFormat('ru-RU', {
				style: 'currency',
				currency: 'RUB',
				maximumFractionDigits: 2
			}).format(number);
		},
		logout() {
			this.$root.axios.post('api/auth/logout')
				.then(res => {
					this.$root.wsLogoutUser();

					this.$cookie.delete('token');

					if (this.$route.name !== 'index') {
						this.$router.push({ name: 'index' });
					}

					this.logoutUser();
				});
		},
		checkRequiredAuthPanel() {
			setTimeout(() => {
				if (this.$route.redirectedFrom?.meta?.checkAuth && !this.user) this.$root.emitter.emit('showModalSignIn');
			}, 0);
		}
	},
	sockets: {
		disconnect: function() {
			this.wsAuth = false;
		},
		connect_error: function() {
			this.wsAuth = false;
		},
		connect: function() {
			this.wsAuthUser();
		},
		notification: function(notify) {
			this.$toast(notify.text, {
				type: notify.type,
				timeout: notify.persistent ? false : toastOptions.timeout,
				position: notify.position ? notify.position : toastOptions.position,
			});
		},
		balance: function(data) {
			this.user.balance = data.balance;
		}
	}
}
</script>